// Path helper for public club-event pages: /evento/:eventId/:slug
export function eventPath(event) {
  if (!event?.event_id) return "/entrada";
  const slug = event.slug ? `/${event.slug}` : "";
  return `/evento/${event.event_id}${slug}`;
}
